
// Test data for Level 3 Wedging Training

export const wedgingTests = [
  {
    id: "wedging-cercles",
    title: "Wedging court",
    description: "Autour d'un trou, sur le green d'entrainement ou sur le parcours choisissez un trou et matérialisez à l'aide de tees 5 cercles de 1, 3, 5, 7, 10 m. Taper 10 balles depuis les distances A=30, B=40, C=50 et compter les points selon le cercle d'arrivée.",
    icon: "🏌️"
  },
  {
    id: "wedging-mid",
    title: "Wedging mi-distance",
    description: "Autour d'un trou, sur le green d'entrainement ou sur le parcours choisissez un trou et matérialisez à l'aide de tees 5 cercles de 1, 3, 5, 7, 10 m. Taper 10 balles depuis les distances D=60, E=70, F=90 et compter les points selon le cercle d'arrivée.",
    icon: "🏌️"
  },
  {
    id: "wedging-pente-gauche",
    title: "Wedging court en pente gauche droite",
    description: "Autour d'un trou, sur le green d'entrainement ou sur le parcours choisissez un trou et matérialisez à l'aide de tees 5 cercles de 1, 3, 5, 7, 10 m. Placer sa balle dans une pente gauche droite, taper 10 balles depuis les distances A1=30, B1=40, C1=50 et compter les points selon le cercle d'arrivée.",
    icon: "🏌️"
  },
  {
    id: "wedging-pente-droite",
    title: "Wedging court en pente droite gauche",
    description: "Autour d'un trou, sur le green d'entrainement ou sur le parcours choisissez un trou et matérialisez à l'aide de tees 5 cercles de 1, 3, 5, 7, 10 m. Placer sa balle dans une pente droite gauche, taper 10 balles depuis les distances A2=30, B2=40, C2=50 et compter les points selon le cercle d'arrivée.",
    icon: "🏌️"
  },
  {
    id: "wedging-mid-pente-gauche",
    title: "Wedging mi-distance en pente gauche droite",
    description: "Autour d'un trou, sur le green d'entrainement ou sur le parcours choisissez un trou et matérialisez à l'aide de tees 5 cercles de 1, 3, 5, 7, 10 m. Placer sa balle dans une pente gauche droite, taper 10 balles depuis les distances D1=60, E1=70, F1=90 et compter les points selon le cercle d'arrivée.",
    icon: "🏌️"
  },
  {
    id: "wedging-mid-pente-droite",
    title: "Wedging mi-distance en pente droite gauche",
    description: "Autour d'un trou, sur le green d'entrainement ou sur le parcours choisissez un trou et matérialisez à l'aide de tees 5 cercles de 1, 3, 5, 7, 10 m. Placer sa balle dans une pente droite gauche, taper 10 balles depuis les distances D2=60, E2=70, F2=90 et compter les points selon le cercle d'arrivée.",
    icon: "🏌️"
  }
];
